import { useRouter } from "next/router";
import { Container, Row, Col } from "reactstrap";
import styles from "./styles.module.scss";
import clsx from "classnames";
import PropTypes from "prop-types";

export default function BreadCrumb({ className, title, color="", customColor="" }) {
  const router = useRouter();
  const isUS = router.asPath.startsWith("/us");
  const homeLink = isUS ? "/us" : "/";

  return (
    <div className={clsx(className, styles.root)}>
      <div className="d-flex align-items-center wrapper flex-wrap">
        <span>
          <a href={homeLink} className={color} style={customColor ? { color: customColor } : null} target="_self">
            Home
          </a>
        </span>
        {title}
      </div>
    </div>
  );
}

BreadCrumb.defaultProps = {
  pathPrefix: "",
  className: "py-2",
};

BreadCrumb.propTypes = {
  pathPrefix: PropTypes.string,
  className: PropTypes.string,
};
